/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlertingHookReferenceDto } from './AlertingHookReferenceDto';
import type { AssetDomainDto } from './AssetDomainDto';
import type { DataProductAssetDynamicInputDto } from './DataProductAssetDynamicInputDto';
import type { DataProductAssetStaticInputDto } from './DataProductAssetStaticInputDto';
import type { DataProductCollaborationToolsParamsDto } from './DataProductCollaborationToolsParamsDto';
import type { DataProductUpstreamNotificationConfigDto } from './DataProductUpstreamNotificationConfigDto';
import type { HealthSummary } from './HealthSummary';
import type { TagReferenceDto } from './TagReferenceDto';
import type { TimeZoneDto } from './TimeZoneDto';
import type { UserDto } from './UserDto';

export type GetDataProductResponseDto = {
    assetInput: (DataProductAssetDynamicInputDto | DataProductAssetStaticInputDto);
    collaborationToolsParams: DataProductCollaborationToolsParamsDto;
    dataProductStatus: GetDataProductResponseDto.dataProductStatus;
    dataProductUpstreamStatus: GetDataProductResponseDto.dataProductUpstreamStatus;
    description?: string;
    domain: AssetDomainDto;
    healthSummary: HealthSummary;
    id: string;
    isNotificationSummaryActivated?: boolean;
    mails: Array<AlertingHookReferenceDto>;
    msTeams: Array<AlertingHookReferenceDto>;
    name: string;
    owners: Array<UserDto>;
    sla?: string;
    slackChannels: Array<AlertingHookReferenceDto>;
    summaryCronExpression?: string;
    summaryCronExpressionTimezone?: TimeZoneDto;
    summaryMails: Array<AlertingHookReferenceDto>;
    summaryMsTeams: Array<AlertingHookReferenceDto>;
    summarySlackChannels: Array<AlertingHookReferenceDto>;
    summaryWebhooks: Array<AlertingHookReferenceDto>;
    tags: Array<TagReferenceDto>;
    upstreamNotificationConfig?: DataProductUpstreamNotificationConfigDto;
    webhooks: Array<AlertingHookReferenceDto>;
};

export namespace GetDataProductResponseDto {

    export enum dataProductStatus {
        HEALTHY = 'HEALTHY',
        AT_RISK = 'AT_RISK',
        CRITICAL = 'CRITICAL',
    }

    export enum dataProductUpstreamStatus {
        HEALTHY = 'HEALTHY',
        AT_RISK = 'AT_RISK',
        CRITICAL = 'CRITICAL',
    }


}
